// extracted by mini-css-extract-plugin
export default {"pageTitleContainer":"PageTitle_pageTitleContainer__M0Dp9","icon":"PageTitle_icon__Isiff","title":"PageTitle_title__usXNQ"};